const availableFields = ['total_1', 'total_4', 'total_5'];

export default availableFields;